<script>
import { ref, reactive, computed } from "vue";
import CTAButton from "./CTAButton.vue";
import { handleVerify } from "../functions";
import {
	apiGetJWTToken,
	apiGetAge,
	apiGetReseller,
	apiGetCar,
	apiPostReservation,
} from "../api";
export default {
	components: {
		CTAButton,
	},
	props: ["nowCar"],
	emits: ["changeCode"],
	setup(props, { emit }) {
		const codeList = ref([
			{ code: "event2021_4series_gran_coupe", text: "THE 4 Gran Coupé" },
			{ code: "event2021_4series_coupe", text: "THE 4 Coupé" },
			{
				code: "event2021_4series_convertible",
				text: "The 4 Convertible",
			},
		]);
		const facebookCodeList = ["G26-4GC", "4-series", "G23"];
		const GAcodeList = [
			"testdrive_4gc",
			"testdrive_4coupe",
			"testdrive_4convertible",
		];
		const carCode = computed({
			get: () => {
				return props.nowCar;
			},
			set: (val) => {
				emit("changeCode", val);
			},
		});

		const tokenVal = ref("");
		const ageRange = ref([]);
		const resellerList = ref({});
		const carBrand = ref({});

		const agreeWithPrivacy = ref(true);
		const formData = reactive({
			data: {
				code: "",
				firstname: "",
				lastname: "",
				gender: 1,
				age: "",
				email: "",
				mobile: "",
				reseller_city: "",
				reseller_store: "",
				brand: "",
				currentcar: "",
				subscribe: false,
				token: "",
			},
		});

		const validationPass = reactive({
			isError: {
				firstname: 0,
				lastname: 0,
				age: 0,
				email: 0,
				mobile: 0,
				reseller_city: 0,
				reseller_store: 0,
				brand: 0,
			},
		});

		apiGetJWTToken()
			.then((token) => {
				tokenVal.value = token.data;
			})
			.catch((err) => {
				console.log(err);
			});
		apiGetAge()
			.then((list) => {
				ageRange.value = list.data;
			})
			.catch((err) => {
				console.log(err);
			});
		apiGetReseller()
			.then((list) => {
				list.data.area.forEach((item) => {
					resellerList.value[item.name] = item.reseller;
				});
			})
			.catch((err) => {
				console.log(err);
			});
		apiGetCar()
			.then((car) => {
				carBrand.value = car.data;
			})
			.catch((err) => {
				console.log(err);
			});

		let pass = new Array(8).fill(true);
		const reset = (property = null, e) => {
			if (property) {
				if (validationPass.isError[property]) {
					formData.data[property] = "";
				}
				validationPass.isError[property] = 0;
				e.target.parentElement.classList.add("hasContent");
			} else {
				formData.data = {
					code: "",
					firstname: "",
					lastname: "",
					gender: 1,
					age: "",
					email: "",
					mobile: "",
					reseller_city: "",
					reseller_store: "",
					brand: "",
					currentcar: "",
					subscribe: false,
					token: "",
				};
				validationPass.isError = {
					firstname: 0,
					lastname: 0,
					age: 0,
					email: 0,
					mobile: 0,
					reseller_city: 0,
					reseller_store: 0,
					brand: 0,
				};
			}
		};
		const inputBlur = (property, e) => {
			if (!formData.data[property]) {
				e.target.parentElement.classList.remove("hasContent");
			} else {
				return;
			}
		};
		const formVerify = () => {
			// is special character
			if (!handleVerify.specialCharacter(formData.data.firstname)) {
				validationPass.isError.firstname = 1;
				pass[0] = false;
			} else {
				pass[0] = true;
			}
			if (!handleVerify.specialCharacter(formData.data.lastname)) {
				validationPass.isError.lastname = 1;
				pass[1] = false;
			} else {
				pass[1] = true;
			}

			// is blank
			if (!handleVerify.empty(formData.data.age)) {
				validationPass.isError.age = 1;
				pass[2] = false;
			} else {
				pass[2] = true;
			}

			// is phone number
			if (!handleVerify.mobile_phone(formData.data.mobile)) {
				validationPass.isError.mobile = 1;
				pass[3] = false;
			} else {
				pass[3] = true;
			}

			// is email format
			if (!handleVerify.email(formData.data.email)) {
				validationPass.isError.email = 1;
				pass[4] = false;
			} else {
				pass[4] = true;
			}

			// is value empty
			if (!handleVerify.empty(formData.data.brand)) {
				validationPass.isError.brand = 1;
				pass[5] = false;
			} else {
				pass[5] = true;
			}

			if (!handleVerify.empty(formData.data.reseller_city)) {
				validationPass.isError.reseller_city = 1;
				pass[6] = false;
			} else {
				pass[6] = true;
			}
			if (!handleVerify.empty(formData.data.reseller_store)) {
				validationPass.isError.reseller_store = 1;
				pass[7] = false;
			} else {
				pass[7] = true;
			}
		};

		const confirmDialog = (msg) => {
			return new Promise((resolve, reject) => {
				let confirmed = window.confirm(msg);
				return confirmed ? resolve(true) : reject(false);
			});
		};

		// const apiLoadingFrame = ref(null);
		// const loadingIndc = ref(null);
		const formPost = async (e) => {
			e.preventDefault();

			gtag("event", "submit", {
				event_category: "testdrive",
				event_label: GAcodeList[carCode.value],
			});

			// verification
			formData.data.code = codeList.value[carCode.value].code;
			formData.data.subscribe = formData.data.subscribe ? "bmw" : false;
			formVerify();
			if (pass.indexOf(false) >= 0) return;

			// is agreed with privacy policy
			if (!agreeWithPrivacy.value) {
				alert("同意本公司的個資處理政策即可預約賞車");
				return;
			}
			if (
				!tokenVal.value ||
				!ageRange.value.length ||
				!Object.keys(resellerList.value).length ||
				!Object.keys(carBrand).length
			) {
				alert("伺服器或網路異常，請稍後再試");
				return;
			}

			formData.data.token = tokenVal.value;

			const bodyFormData = new FormData();
			Object.keys(formData.data).forEach((item) => {
				if (item !== "agreeWithPolicy") {
					bodyFormData.append(item, formData.data[item]);
				}
			});
			const apiLoadingFrame = document.querySelector(".apiLoadingFrame");
			const loadingIndc = document.querySelector(".loading-indicator");

			try {
				apiLoadingFrame.style.display = "block";
				apiLoadingFrame.style.opacity = 1;
				apiLoadingFrame.style.zIndex = 2000;
				loadingIndc.style.display = "block";
				loadingIndc.style.opacity = 1;
				loadingIndc.style.zIndex = 2010;
				document.documentElement.style.overflowY = "hidden";

				const response = await apiPostReservation(bodyFormData);
				if (response.data.status < 0) {
					alert("資料傳送失敗，請再試一次");
				} else {
					const id = process.env.VUE_APP_PIXELID;
					const id2 = process.env.VUE_APP_PIXELID2;
					const content_ids = facebookCodeList[carCode.value];

					fbq(
						"trackSingleCustom",
						id,
						"Lead",
						// begin parameter object data
						{ content_ids, content_type: "automotive_model" }
						// end parameter object data
					);
					fbq("trackSingleCustom", id2, "Lead");

					function gtag_report_conversion(url) {
						var callback = function() {
							if (typeof url != "undefined") {
								window.location = url;
							}
						};
						gtag("event", "conversion", {
							send_to: `${process.env.VUE_APP_AWID}/IiGhCP_iy4YBENPdlvsC`,
							event_callback: callback,
						});
						gtag("event", "conversion", {
							send_to: `${process.env.VUE_APP_AWID2}/arKyCOCjvJIDENqxudcB`,
						});
						return false;
					}
					gtag("event", "success", {
						event_category: "testdrive",
						event_label: GAcodeList[carCode.value],
					});
					gtag_report_conversion();

					_lt("send", "cv", { type: "Conversion" }, [
						process.env.VUE_APP_LINEID,
					]);

					window.dotq = window.dotq || [];
					window.dotq.push({
						projectId: process.env.VUE_APP_YAHOO_PROJECTID,
						properties: {
							pixelId: process.env.VUE_APP_YAHOO_PIXELID,
							qstrings: {
								et: "custom",
								ea: "submit_BMW_4GC",
							},
						},
					});

					window.onead_pixel.push({
						type: "tracker",
						value: { name: "Lead" },
					});

					window.appier_q = window.appier_q || [];
					window.appier_q.push({
						t: "type_conversion",
						content: "submit",
						action_id: process.env.VUE_APP_APPIER_CONVERSIONID,
						track_id: process.env.VUE_APP_APPIER_TRACKID,
						opts: { unique_key: "true" },
					});

					confirmDialog("預約賞車成功！ 是否回到首頁？")
						.then(() => {
							reset();
							const inputs = document.querySelectorAll(
								".input-wrapper, .select-wrapper"
							);
							inputs.forEach((elem) => {
								elem.classList.remove("hasContent");
							});

							const top = document
								.querySelector("#story")
								.getBoundingClientRect().top;
							document.body.scrollTo({
								top: document.body.scrollTop + top,
								behavior: "smooth",
							});
						})
						.catch((err) => {
							console.log(err);
							reset();
							const inputs = document.querySelectorAll(
								".input-wrapper, .select-wrapper"
							);
							inputs.forEach((elem) => {
								elem.classList.remove("hasContent");
							});
						});
				}

				apiLoadingFrame.style.display = "none";
				apiLoadingFrame.style.opacity = 0;
				apiLoadingFrame.style.zIndex = "auto";
				loadingIndc.style.display = "none";
				loadingIndc.style.opacity = 0;
				loadingIndc.style.zIndex = "auto";
				document.documentElement.style.overflowY = "hidden";
			} catch (error) {
				console.log(error);

				apiLoadingFrame.style.display = "none";
				apiLoadingFrame.style.opacity = 0;
				apiLoadingFrame.style.zIndex = "auto";
				loadingIndc.style.display = "none";
				loadingIndc.style.opacity = 0;
				loadingIndc.style.zIndex = "auto";
				document.documentElement.style.overflowY = "hidden";

				alert("資料傳送失敗，請再試一次");
			}
		};

		return {
			carCode,
			codeList,
			formData,
			inputBlur,
			validationPass,
			reset,
			tokenVal,
			ageRange,
			resellerList,
			carBrand,
			agreeWithPrivacy,
			formPost,
			GAcodeList,
		};
	},
};
</script>

<template>
	<div class="reservation">
		<div class="reservation-form" id="form">
			<div class="form-title text_ch_heavy"><slot></slot></div>
			<form autocomplete="off">
				<div class="form-div">
					<div class="form-title_sub text_ch_medium">請選擇車款</div>
					<div id="code" class="select-wrapper">
						<select
							class="text_en_thin"
							name="code"
							v-model="carCode"
						>
							<option
								v-for="(item, idx) in codeList"
								:key="item.code"
								class="text_en_thin"
								:value="idx"
							>
								{{ item.text }}
							</option>
						</select>
						<span class="select-arrow"></span>
					</div>
				</div>
				<div class="form-div"></div>
				<div class="form-div">
					<div class="form-title_sub text_ch_medium">
						請輸入基本資料
					</div>
					<div
						class="input-wrapper"
						data-message="姓氏不可空白，或包含特殊符號"
						data-placeholder="姓氏"
						:data-pass="validationPass.isError.firstname"
					>
						<input
							type="text"
							name="firstname"
							v-model="formData.data.firstname"
							@focus="reset('firstname', $event)"
							@blur="inputBlur('firstname', $event)"
						/>
					</div>
					<div
						class="input-wrapper"
						data-message="名字不可空白，或包含特殊符號"
						data-placeholder="名字"
						:data-pass="validationPass.isError.lastname"
					>
						<input
							type="text"
							name="lastname"
							v-model="formData.data.lastname"
							@focus="reset('lastname', $event)"
							@blur="inputBlur('lastname', $event)"
						/>
					</div>
					<div class="wrapper">
						<div
							class="select-wrapper age"
							data-message="請選擇年齡"
							data-placeholder="年齡"
							:data-pass="validationPass.isError.age"
						>
							<select
								name="age"
								v-model="formData.data.age"
								@focus="reset('age', $event)"
								@blur="inputBlur('age', $event)"
							>
								<option value="null" disabled>
									年齡
								</option>
								<option
									v-for="item in ageRange"
									:value="item"
									:key="item"
								>
									{{ item }}
								</option>
							</select>
							<span class="select-arrow"></span>
						</div>
						<div class="gender">
							<div class="radio-for-male">
								<span class="radiobox"></span>
								<span class="text_ch_medium radio-text"
									>先生</span
								>
								<input
									type="radio"
									name="gender"
									value="1"
									checked
									v-model.number="formData.data.gender"
								/>
								<span class="radio"></span>
							</div>
							<div class="radio-for-female">
								<span class="radiobox"></span>
								<span class="text_ch_medium radio-text"
									>女士</span
								>
								<input
									type="radio"
									name="gender"
									value="0"
									v-model.number="formData.data.gender"
								/>
								<span class="radio"></span>
							</div>
						</div>
					</div>
					<div
						class="input-wrapper"
						data-message="請輸入以 09 開頭的 10 位數手機號碼"
						data-placeholder="手機號碼"
						:data-pass="validationPass.isError.mobile"
					>
						<input
							type="text"
							name="mobile"
							v-model="formData.data.mobile"
							@focus="reset('mobile', $event)"
							@blur="inputBlur('mobile', $event)"
						/>
					</div>
					<div
						class="input-wrapper"
						data-message="請輸入正確的信箱格式"
						data-placeholder="E-MAIL"
						:data-pass="validationPass.isError.email"
					>
						<input
							class="text_en_thin"
							type="text"
							name="email"
							v-model="formData.data.email"
							@focus="reset('email', $event)"
							@blur="inputBlur('email', $event)"
						/>
					</div>
				</div>
				<div class="form-div">
					<div class="form-title_sub text_ch_medium">
						現有車款品牌
					</div>
					<div
						class="select-wrapper"
						data-message="請選擇車款品牌"
						data-placeholder="選擇車款品牌"
						:data-pass="validationPass.isError.brand"
					>
						<select
							name="brand"
							v-model="formData.data.brand"
							@focus="reset('brand', $event)"
							@blur="inputBlur('brand', $event)"
						>
							<option value="null" disabled>
								選擇車款品牌
							</option>
							<option
								v-for="(item, key) in carBrand"
								:value="key"
								:key="key"
							>
								{{ key }}
							</option>
						</select>
						<span class="select-arrow"></span>
					</div>
					<div
						class="input-wrapper"
						data-message="請輸入您現有的車款"
						data-placeholder="現有車款"
						:data-pass="validationPass.isError.currentcar"
						v-show="
							carBrand[formData.data.brand]
								? !carBrand[formData.data.brand].length
								: false
						"
					>
						<input
							type="text"
							name="currentcar"
							v-model="formData.data.currentcar"
							@focus="reset('currentcar', $event)"
							@blur="inputBlur('currentcar', $event)"
						/>
					</div>
					<div
						class="select-wrapper"
						v-show="
							carBrand[formData.data.brand]
								? carBrand[formData.data.brand].length
								: true
						"
						data-message="請選擇現有車款"
						data-placeholder="選擇現有車款"
						:data-pass="validationPass.isError.currentcar"
					>
						<select
							name="currentcar"
							v-model="formData.data.currentcar"
							@focus="reset('currentcar', $event)"
							@blur="inputBlur('currentcar', $event)"
						>
							<option value="null" disabled>
								選擇現有車款
							</option>
							<option
								v-for="item in carBrand[formData.data.brand]"
								:value="item"
								:key="item"
							>
								{{ item }}
							</option>
						</select>
						<span class="select-arrow"></span>
					</div>
					<div class="form-title_sub text_ch_medium">
						希望與您聯絡的 BMW 經銷商
					</div>
					<div
						class="select-wrapper"
						data-message="請選擇地區"
						data-placeholder="選擇地區"
						:data-pass="validationPass.isError.reseller_city"
					>
						<select
							name="reseller_city"
							v-model="formData.data.reseller_city"
							@focus="reset('reseller_city', $event)"
							@blur="inputBlur('reseller_city', $event)"
						>
							<option value="null" disabled>
								選擇地區
							</option>
							<option
								v-for="(item, key) in resellerList"
								:value="key"
								:key="key"
							>
								{{ key }}
							</option>
						</select>
						<span class="select-arrow"></span>
					</div>
					<div
						class="select-wrapper"
						data-message="請選擇希望聯繫您的經銷商"
						data-placeholder="選擇經銷商"
						:data-pass="validationPass.isError.reseller_store"
					>
						<select
							name="reseller_store"
							v-model="formData.data.reseller_store"
							@focus="reset('reseller_store', $event)"
							@blur="inputBlur('reseller_store', $event)"
						>
							<option value="null" disabled>
								選擇經銷商
							</option>
							<option
								v-for="item in resellerList[
									formData.data.reseller_city
								]"
								:value="item"
								:key="item"
							>
								{{ item }}
							</option>
						</select>
						<span class="select-arrow"></span>
					</div>
				</div>
				<div class="form-div form-div-2">
					<div class="check-for-subscribe">
						<span class="radiobox"></span>
						<span class="text_concent radio-text text_ch_medium">
							我想訂閱 <span class="text_en_regular">BMW </span>
							電子報，隨時掌握品牌動態、新車情報、售後服務等最新資訊。
						</span>
						<input
							type="checkbox"
							name="subscribe"
							v-model="formData.data.subscribe"
						/>
						<span class="radio"></span>
					</div>
					<div class="check-for-privacy">
						<span class="radiobox"></span>
						<span class="text_concent radio-text text_ch_medium">
							我同意
							<span class="text_en_regular">BMW </span>
							總代理汎德股份有限公司得將本人之個人資料經電腦處理後，
							<span class="text_en_regular">BMW</span>
							總代理汎德股份有限公司及其所屬汎德股份有限公司其他關係企業暨其特約經銷商等使用，以及為提升客戶服務品質、車輛資訊之提供及推廣客戶關懷活動而使用。
							<br />
							* 僅部分車型提供試乘車，詳情請洽全台展示中心
						</span>
						<input
							type="checkbox"
							checked
							name="agreeWithPrivacy"
							v-model="agreeWithPrivacy"
						/>
						<span class="radio"></span>
					</div>
					<div class="button-wrapper">
						<CTAButton @click="formPost">確認送出</CTAButton>
					</div>
				</div>
			</form>
		</div>
		<!-- <div class="apiLoadingFrame" ref="apiLoadingFrame"></div> -->
		<!-- <div class="loading-indicator" ref="loadingIndc">
			<div class="loading-ring">
				<div class="inner-ring"></div>
			</div>
			<div class="t-ring">
				<div class="bar bar1"></div>
				<div class="bar bar2"></div>
				<div class="bar bar3"></div>
				<div class="bar bar4"></div>
				<div class="bar bar5"></div>
			</div>
		</div> -->
	</div>
</template>

<style lang="sass" scoped>

.reservation
	position: relative
	// top: -100vh
	// height: 100vh
	display: flex
	justify-content: center
	align-items: center
	.reservation-form
		position: relative
		width: 90vw
		max-width: 90%
		// height: auto
		// max-height: 90%
		z-index: 1
		background-color: #1112
		backdrop-filter: blur(15.3px)
		-webkit-backdrop-filter: blur(15.3px)
		.form-title
			padding-top: 2rem
			padding-bottom: 2rem
			font-size: 3.6rem
			letter-spacing: 5.4px
			text-align: center
		form
			width: 80%
			max-width: 1080px
			margin: 0 auto

.form-div
	display: inline-block
	width: calc(50% - 7.4vw)
	padding: 0px 3.7vw
	margin-bottom: 30px
	&.form-div-2
		position: relative
		width: calc(100% - 7.4vw)
		margin-bottom: 40px
		.button-wrapper
			margin-top: 40px
			position: relative
			height: 64px
			.CTA-button
				left: 50%
				bottom: 20px
				transform: translateX(-50%)
	.form-title_sub
		font-size: 2.4rem
		line-height: 2
		letter-spacing: 0.24px
	.form-title_sub:nth-child(5)
		margin-top: 2%
		height: calc(50px - 2%)
		line-height: calc(50px - 2%)
	.wrapper
		position: relative
		display: flex
		justify-content: flex-end
		align-items: baseline
		.age
			display: inline-block
			width: calc(100% - 130px)
			margin-right: 30px
			flex-shrink: 1
			flex-basis: calc(100% - 130px)
		.gender
			position: relative
			right: 0
			width: 150px
			display: flex
			justify-content: space-between
			align-items: center
	.input-wrapper, .select-wrapper
		&::before
			content: attr(data-placeholder)
			position: absolute
			width: 100%
			height: 100%
			left: 0
			top: 0
			font-size: 1.5rem
			font-family: arudjingxiheipe1xg30_md, 微軟正黑體
			letter-spacing: 0.53px
			line-height: 50px
			color: #fff
			opacity: 1
			z-index: 0
		&::after
			content: attr(data-message)
			position: absolute
			width: 100%
			height: 100%
			right: 0
			top: 0
			text-align: right
			font-family: arudjingxiheipe1xg30_md, 微軟正黑體
			font-size: 1.2rem
			letter-spacing: 0.42px
			color: rgba(#ccc, 0.9)
			line-height: 50px
			opacity: 0
			z-index: 0
		&.hasContent
			&::before
				opacity: 0
	.input-wrapper[data-pass="1"], .select-wrapper[data-pass="1"]
		&::after
			opacity: 1
	.input-wrapper
		position: relative
	.input-wrapper[data-placeholder="E-MAIL"]
		&::before
			font-family: "BMWTypeNextLatinTT-Thin", serif
	.select-wrapper
		position: relative
		&::after
			right: 20px
		&#code
			&::after
				content: none
		.select-arrow
			position: absolute
			width: 12px
			height: 12px
			right: 0
			top: 50%
			transform: translateY(-50%)
			background-image: url("~@/assets/arrow_select.png")
			background-size: 80% auto
			background-position: center
			background-repeat: no-repeat

	input, select, option, label
		display: block
		position: relative
		margin: 0
		padding: 0
		border: none
		background-color: transparent
		-webkit-appearance: none
		-moz-appearance: none
		appearance: none
		outline: none
		font-size: 1.5rem
		border-radius: 0px
		border-bottom: solid 1px rgba(#fff, 0.2)
		font-family: "BMWTypeNextLatinTT-Thin", arudjingxiheipe1xg30_md, serif, 微軟正黑體
	input[type="text"]
		width: calc(100% - 4px)
		height: 50px
		--webkit-user-select: text !important

	input[type="radio"], input[type="checkbox"]
		// position: absolute
		// display: inline-block
		// height: 21px
		border-bottom: none

	input[type="checkbox"]
        left: 0
        top: 0
        &::before, &::after
            left: 0px

	.radio-for-male, .radio-for-female, .check-for-subscribe, .check-for-privacy
		position: relative
		.radiobox
			display: inline-block
			width: 18px
			height: 18px
			margin-right: 8px
			border: solid 1px #eee
			opacity: 0.5
			vertical-align: middle
		.radio-text
			display: inline-block
			font-size: 1.5rem
			letter-spacing: 0.53px
			text-align: right
			vertical-align: middle
			&.text_concent
				text-align: left
		.radio
			position: absolute
			width: 18px
			height: 18px
			left: 0px
			top: 50%
			opacity: 0
			transform: translateY(-50%)
			background-image: url("~@/assets/check-solid.png")
			background-size: 70% auto
			background-position: center
			background-repeat: no-repeat
		input
			position: absolute
			width: 100%
			height: 100%
			left: 0
			top: 0
			z-index: 10
		input:checked + .radio
			opacity: 1

	.check-for-subscribe, .check-for-privacy
		margin-bottom: 20px
		.radiobox
			vertical-align: top
		.text_concent
			width: calc(100% - 28px)
			font-size: 1.3rem
			line-height: 1.62
			letter-spacing: 0.65px
			color: #eee
			span
				font-size: inherit
				color: #eee
		.radio
			top: 2px
			transform: translateY(0)

	select
        width: 100%
        height: 50px
        z-index: 10
        cursor: pointer

	option
        color: #000
	// // WebKit, Blink, Edge
    // ::-webkit-input-placeholder
	// 	color: #fff
	// // Mozilla Firefox 4 to 18
    // :-moz-placeholder
	// 	color: #fff
	// 	opacity: 1
	// // Mozilla Firefox 19+
	// ::-moz-placeholder
	// 	color: #fff
	// 	opacity: 1
	// // Internet Explorer 10-11
	// :-ms-input-placeholder
    //     color: #fff
	// // Microsoft Edge
	// ::-ms-input-placeholder
    //     color: #fff
	// // Most modern browsers support this now.
    // ::placeholder
    //     color: #fff

@media screen and (max-width: 1600px)
	.reservation
		#form
			form
				.form-div
					&.form-div-2
						.button-wrapper
							.CTA-button
								transform: translateX(-50%) scale(0.9)
@media screen and (max-width: 1200px)
	.reservation
		#form
			form
				.form-div
					&.form-div-2
						.button-wrapper
							.CTA-button
								transform: translateX(-50%) scale(0.8)
@media screen and (max-width: 800px)
	.reservation
		#form
			form
				.form-div
					&.form-div-2
						.button-wrapper
							.CTA-button
								transform: translateX(-50%) scale(0.7)

@media screen and (max-width: 992px)
    .reservation
        .reservation-form
            form
                width: 90%
@media screen and (max-width: 768px)
	.reservation
		// height: 180vh
		align-items: flex-start
		.apiLoadingFrame
			// height: 180vh
		#form
			margin-top: 10vw
			max-height: none
			.form-title
				padding-top: 4rem
				padding-bottom: 4rem
				font-size: 1.8rem
				letter-spacing: 3.24px
			form
				width: 80%
				.form-title_sub
					font-size: 1.5rem
					letter-spacing: 0.15px
				.form-div
					width: calc(100% - 7.4vw)
					margin-bottom: 40px
					.form-title_sub:nth-child(5)
						margin-top: 30px
					.input-wrapper, .select-wrapper
						&::after, &::before
							line-height: 40px
						&::before
							font-size: 1.2rem
							letter-spacing: 0.42px
						&::after
							font-size: 1rem
							letter-spacing: -0.1px
							right: auto
							top: 40px
							left: 0
							transform: none
							text-align: center
					.input-wrapper[data-pass="1"], .select-wrapper[data-pass="1"]
						height: 70px
					.select-wrapper[data-pass="1"]
						.select-arrow
							top: calc((100% - 30px) / 2)
					.radio-for-male, .radio-for-female, .check-for-subscribe, .check-for-privacy
						.radio-text
							font-size: 1.2rem
							letter-spacing: 0.42px
					.check-for-privacy
						.radio-text
							line-height: 1.62
							letter-spacing: 0.6px
					input, select, option, label
						font-size: 1.2rem
					input[type="text"], select
						height: 40px
					&.form-div-2
						margin-bottom: 20px
						.button-wrapper
							.CTA-button
								transform: translateX(-50%) scale(0.6)

				.form-div:nth-child(2)
					margin-bottom: 0
</style>
